
import { formatItemQty } from '@/utils/formatUnit'
import OrderTimeline from '@/components/common/OrderTimeline.vue'
import OrderLocationMap from '@/components/common/OrderLocationMap.vue'
import PhoneCallButton from '@/components/common/PhoneCallButton.vue'
import BaseActionButton from '@/components/common/BaseActionButton.vue'
import DeliveryConfirmDrawer from '@/components/order/DeliveryConfirmDrawer.vue'
export default {
  name: 'CourierMobileOrderDetail',
  components: { OrderTimeline, OrderLocationMap, PhoneCallButton, BaseActionButton, DeliveryConfirmDrawer },
  data () {
    return {
      order: null,
      loading: true,
      orderId: '',
      showDeliveryDrawer: false
    }
  },
  created () {
    this.orderId = this.$route.params.id
    this.fetchOrderDetail()
  },
  methods: {
    formatItemQty,
    async fetchOrderDetail () {
      this.loading = true
      try {
        const res = await this.axios.get(`/courier-mobile/orders/${this.orderId}`)
        if (res.data.code === 200) {
          this.order = res.data.data
        }
      } catch (err) {
        console.error('获取订单详情失败:', err)
        this.$q.notify({ type: 'negative', message: '获取订单详情失败' })
      } finally {
        this.loading = false
      }
    },
    async startDelivery () {
      try {
        const res = await this.axios.post(`/courier-mobile/orders/${this.orderId}/start`)
        if (res.data.code === 200) {
          this.$q.notify({ type: 'positive', message: '已开始配送' })
          this.fetchOrderDetail()
        }
      } catch (err) {
        this.$q.notify({ type: 'negative', message: err.response?.data?.message || '操作失败' })
      }
    },
    markDelivered () {
      // 打开统一送达确认抽屉(照片/备注/提交内聚在 DeliveryConfirmDrawer,不再直发)
      this.showDeliveryDrawer = true
    },
    getStatusDesc (status) {
      const map = {
        'inspected': '等待您开始配送',
        'delivering': '配送中，请尽快送达',
        'delivered': '已成功送达'
      }
      return map[status] || ''
    },
    formatTime (timeStr) {
      if (!timeStr) return '-'
      const date = new Date(timeStr)
      return `${date.getMonth() + 1}/${date.getDate()} ${date.getHours().toString().padStart(2, '0')}:${date.getMinutes().toString().padStart(2, '0')}`
    }
  }
}
